import {createContext, useState} from "react";

export const CitizenContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [citizen, setCitizen] = useState(null);
    const [citizens, setCitizens] = useState([]);
    const [citizenDialog, setCitizenDialog] = useState(false);

    // Make the context object:
    const citizenContext = {
        citizen,
        setCitizen,
        citizens,
        setCitizens,
        citizenDialog,
        setCitizenDialog,
    };

    // pass the value in provider and return
    return <CitizenContext.Provider value={citizenContext}>{children}</CitizenContext.Provider>;
}

export const {Consumer} = CitizenContext;
